import {
	Popover as AriaPopover,
	Menu as AriaMenu,
	MenuItem as AriaMenuItem,
	MenuItemProps,
	MenuProps,
	PopoverProps,
} from 'react-aria-components'

export function Popover({ className = '', ...props }: PopoverProps) {
	return (
		<AriaPopover
			className={`${className} bg-white rounded border border-gray-200 shadow-xl shadow-gray-200`}
			{...props}
		/>
	)
}

export function Menu<T extends object>({ className = '', ...props }: MenuProps<T>) {
	return (
		<AriaMenu
			className={`${className} flex flex-col gap-[1px] p-2 outline outline-0`}
			{...props}
		/>
	)
}

export function MenuItem({ className = '', ...props }: MenuItemProps) {
	return (
		<AriaMenuItem
			className={({ isFocused }) =>
				`${className} cursor-pointer px-2 py-1 outline-0 rounded hover:bg-blue-50 ${isFocused ? 'bg-blue-50' : ''}`
			}
			{...props}
		/>
	)
}
